import { store } from "../../reduxStore/store"
import {
  authenticated,
  logoutSession,
  msalToVeapInfo,
  unauthenticated,
} from "./authenticationSlice"
import msalInstance from "./msalClient/msal"
import appInsightsLogger from "../logging/appInsightsLogger"

export const checkAndRefreshToken = async (): Promise<void> => {
  const activeAccount = msalInstance.getMsalInstance().getActiveAccount()
  if (!!activeAccount) {
    try {
      const response = await msalInstance.refreshTokenSilently()

      // Update the store with the new account information if it exists
      if (response) {
        const updatedAccountInfo = msalToVeapInfo(response.account)
        store.dispatch(authenticated(updatedAccountInfo))
        appInsightsLogger.traceInfo(
          "Token Refresh: Token refreshed successfully",
        )
      }
    } catch (error) {
      appInsightsLogger.traceError(
        `Token Refresh: Error refreshing token: ${error}`,
      )
      store.dispatch(logoutSession())
      store.dispatch(unauthenticated())
    }
  }
}
